import * as React from "react";
const PlaceholderBtn = () => React.createElement(React.Fragment, null,
    React.createElement("div", { className: `rj-ev-list__ev-card-placeholder__buttons` },
        React.createElement("div", { className: `rj-ev-list__ev-card-placeholder__buttons-text` }),
        React.createElement("div", { className: `rj-ev-list__ev-card-placeholder__buttons-odd` })),
    React.createElement("div", { className: `rj-ev-list__ev-card-placeholder__buttons` },
        React.createElement("div", { className: `rj-ev-list__ev-card-placeholder__buttons-text` }),
        React.createElement("div", { className: `rj-ev-list__ev-card-placeholder__buttons-odd` })),
    React.createElement("div", { className: `rj-ev-list__ev-card-placeholder__buttons` },
        React.createElement("div", { className: `rj-ev-list__ev-card-placeholder__buttons-text` }),
        React.createElement("div", { className: `rj-ev-list__ev-card-placeholder__buttons-odd` })),
    React.createElement("div", { className: `rj-ev-list__ev-card-placeholder__empty-element` }));
PlaceholderBtn.displayName = "PlaceholderBtn";
export default React.memo(PlaceholderBtn);
//# sourceMappingURL=PlaceholderBtn.js.map